import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Loader({ onDone }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let raf;
    const start = performance.now();
    const DURATION = 1900;
    const step = (t) => {
      const elapsed = t - start;
      const p = Math.min(1, elapsed / DURATION);
      setProgress(p);
      if (p < 1) raf = requestAnimationFrame(step);
      else setTimeout(() => onDone && onDone(), 300);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [onDone]);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        className="fixed inset-0 z-50 flex items-center justify-center bg-[#050307]"
        data-testid="world-loader"
      >
        <div className="absolute inset-0 hero-gradient opacity-70" />
        <div className="absolute inset-0 grid-backdrop opacity-40" />
        <div className="relative flex flex-col items-center gap-6 px-6">
          <motion.img
            src="/greinch-logo.png"
            alt="GREINCH"
            className="h-24 sm:h-28 w-auto drop-shadow-[0_0_40px_rgba(233,75,75,0.55)]"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: [0.2, 0.8, 0.2, 1] }}
          />
          <div className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.28em] text-[#B9AFA6]">
            Booting GREINCH Airspace…
          </div>
          <div className="w-64 sm:w-80 h-[3px] bg-[rgba(244,234,222,0.10)] overflow-hidden rounded-full">
            <div
              className="h-full bg-gradient-to-r from-[#6B1F47] via-[#E94B4B] to-[#F4EADE]"
              style={{ width: `${Math.round(progress * 100)}%`, transition: "width 60ms linear" }}
            />
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#EFE3D6]/70">
            {progress < 0.35 ? "Aligning waypoints…" : progress < 0.7 ? "Powering runways…" : progress < 0.98 ? "Clearance granted…" : "Cleared for takeoff"}
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
